import React, { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { TICKER_HEADLINES } from "../../lib/constants";

export function NewsTicker({ className, speed = 35 }) {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);

    const handler = (e) => setPrefersReducedMotion(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  // Join headlines with separator
  const tickerContent = TICKER_HEADLINES.map(
    (headline) => `${headline}`
  ).join(" \u2022 ");

  // Reduced motion: show static first headline
  if (prefersReducedMotion) {
    return (
      <div
        className={cn(
          "bg-ink text-paper py-3 px-4",
          "font-sans text-sm",
          className
        )}
      >
        <span className="font-bold text-gold mr-2">LATEST:</span>
        {TICKER_HEADLINES[0]}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "bg-ink text-paper overflow-hidden",
        "py-3",
        "group",
        "animate-on-load animate-fade-in stagger-4",
        className
      )}
      role="marquee"
      aria-live="off"
      aria-label="Latest mining news headlines"
    >
      <div
        className={cn(
          "flex whitespace-nowrap",
          "animate-ticker",
          "group-hover:[animation-play-state:paused]"
        )}
        style={{
          "--ticker-speed": `${speed}s`,
        }}
      >
        {/* Duplicate content for seamless loop */}
        <span className="flex items-center">
          <span className="font-bold text-gold mx-4">BREAKING</span>
          <span className="font-body text-sm tracking-wide">
            {tickerContent}
          </span>
        </span>
        <span className="flex items-center" aria-hidden="true">
          <span className="font-bold text-gold mx-4">BREAKING</span>
          <span className="font-body text-sm tracking-wide">
            {tickerContent}
          </span>
        </span>
      </div>
    </div>
  );
}
